import { clamp } from 'lodash';

export const copilotDrawerWidth = 420;
export const copilotDrawerMinWidth = 320;
export const copilotDrawerMaxWidth = 720;
export const copilotDrawerWidthStorageKey = 'copilotDrawerWidth';

const copilotDrawerViewportGutter = 48;
const copilotDrawerFullWidthBreakpoint = 768;
const copilotDrawerPreferredViewportRatio = 0.34;
const copilotDrawerMinMainAreaWidth = 640;

const normalizeViewportWidth = (viewportWidth: number) =>
  Number.isFinite(viewportWidth) && viewportWidth > 0 ? viewportWidth : copilotDrawerWidth;

export const getCopilotDrawerWidthBounds = (viewportWidth: number) => {
  const normalizedViewportWidth = normalizeViewportWidth(viewportWidth);

  if (normalizedViewportWidth <= copilotDrawerMinWidth) {
    return {
      minWidth: normalizedViewportWidth,
      maxWidth: normalizedViewportWidth,
    };
  }

  if (normalizedViewportWidth <= copilotDrawerFullWidthBreakpoint) {
    const maxWidth = Math.max(0, normalizedViewportWidth - copilotDrawerViewportGutter);

    return {
      minWidth: Math.min(copilotDrawerMinWidth, maxWidth),
      maxWidth,
    };
  }

  const maxWidth = Math.min(
    copilotDrawerMaxWidth,
    normalizedViewportWidth - copilotDrawerViewportGutter,
    Math.max(copilotDrawerMinWidth, normalizedViewportWidth - copilotDrawerMinMainAreaWidth)
  );
  const minWidth = Math.min(copilotDrawerMinWidth, maxWidth);

  return {
    minWidth,
    maxWidth,
  };
};

export const getDefaultCopilotDrawerWidth = (viewportWidth: number) => {
  const normalizedViewportWidth = normalizeViewportWidth(viewportWidth);
  const { minWidth, maxWidth } = getCopilotDrawerWidthBounds(normalizedViewportWidth);

  if (normalizedViewportWidth <= copilotDrawerFullWidthBreakpoint) {
    return maxWidth;
  }

  return clamp(Math.round(normalizedViewportWidth * copilotDrawerPreferredViewportRatio), minWidth, maxWidth);
};

export const normalizeCopilotDrawerWidth = (width: number, viewportWidth: number) => {
  const { minWidth, maxWidth } = getCopilotDrawerWidthBounds(viewportWidth);
  const fallbackWidth = getDefaultCopilotDrawerWidth(viewportWidth);

  if (!Number.isFinite(width)) {
    return fallbackWidth;
  }

  return clamp(Math.round(width), minWidth, maxWidth);
};
